import styled from "@emotion/styled";

/**
 * To be used to wrap a DefaultContainer. Has padding.
 */
export const DefaultWrapper = styled.div`
  width: 100%;
  padding: 0 36px;
`;
